// Hari K:08-11-2023 :BT-119138:Funds View -mandate report modal-start

import { memo } from "react";
import { BzButton, BzChip, BzModal, BzModalBody, BzModalHeader } from "../../components";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { handleModal } from "../../redux/actions/modals";

const MandateDetailsModal = () => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state.modals.modals);

    const onHide = () => {
        dispatch(handleModal([{ "MANDATE_DETAILS_MODAL": false }]));
    };

    const mandateDetails = {
        id: "27209493",
        bankName: "HDFC",
        amount: "500",
        limitAvailable: "500.00",
        status: "isRejected",
        accountTypeNumber: 'SB-01211540000281',
        lastUpdate: "30/10/2023/",
        IFCRCode: 'HDFC0000121',
        MIRCCode: '',
        mandateStartDate: "30/10/2023",
        mandateEndDate: "30/10/2023",
        remark: "MANDATE REGESTRATION DONE SUCCESSFULLY",
        mandateType: 'E-Mandate'
    };


    return (
        <>
            {/* SumitG-08-12-23 */}
            <BzModal show={modals['MANDATE_DETAILS_MODAL']} onHide={onHide}>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={10} className='d-flex justify-content-start align-self-center'>
                                <div className='font-medium font-size4 color-text'>Mandate Details</div>
                            </Col>
                            <Col md={2} className='d-flex justify-content-end align-self-center'>
                                <div className='icon-16 icon-close icon-dark' onClick={onHide}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <div className='py-3 bdr-btm mb-3'>
                            <Row className='g-0'>
                                <Col md={9} className='d-flex flex-column align-items-start'>
                                    <div className='font-regular font-size3 color-text'>Auto Debit from</div>
                                    <div className='font-medium font-size5 color-text text-uppercase pt-1'>HDFC BANK</div>
                                    <div className='font-medium font-size2 color-text pt-1'>Limit available: <span className='font-regular'>500.00</span></div>
                                </Col>
                                <Col md={3} className='d-flex justify-content-end align-items-start'>
                                    <div className='font-medium font-size4 color-text'>&#8377;500</div>
                                </Col>
                            </Row>
                            <Row className='g-0 mt-1'>
                                <Col md={9} className='d-flex justify-content-start align-items-center'>
                                    <div className='multi-chips-wrap'>
                                        <div className='chips-wrap'>
                                            <BzChip className='chips text-capitalize positive-chip'>Rejected</BzChip>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={3} className='d-flex justify-content-end align-items-center'>
                                    <BzButton className='btn btn-md btn-primary btn-rounded'>Download</BzButton>
                                </Col>
                            </Row>
                        </div>
                        <Row className='g-0 py-1'>
                            <Col md={6} className='d-flex justify-content-start align-items-center'>
                                <div className='font-regular font-size2 color-subtext'>ID</div>
                            </Col>
                            <Col md={6} className='d-flex justify-content-end align-items-center text-end'>
                                <div className='font-regular font-size2 color-text text-wrap'>{mandateDetails.id}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 py-1'>
                            <Col md={6} className='d-flex justify-content-start align-items-center'>
                                <div className='font-regular font-size2 color-subtext'>A/C Type-Number</div>
                            </Col>
                            <Col md={6} className='d-flex justify-content-end align-items-center text-end'>
                                <div className='font-regular font-size2 color-text text-wrap'>{mandateDetails.accountTypeNumber}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 py-1'>
                            <Col md={6} className='d-flex justify-content-start align-items-center'>
                                <div className='font-regular font-size2 color-subtext'>Last Updated</div>
                            </Col>
                            <Col md={6} className='d-flex justify-content-end align-items-center text-end'>
                                <div className='font-regular font-size2 color-text text-wrap'>{mandateDetails.lastUpdate}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 py-1'>
                            <Col md={6} className='d-flex justify-content-start align-items-center'>
                                <div className='font-regular font-size2 color-subtext'>IFSC Code</div>
                            </Col>
                            <Col md={6} className='d-flex justify-content-end align-items-center text-end'>
                                <div className='font-regular font-size2 color-text text-wrap'>{mandateDetails.IFCRCode}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 py-1'>
                            <Col md={6} className='d-flex justify-content-start align-items-center'>
                                <div className='font-regular font-size2 color-subtext'>MICR Code</div>
                            </Col>
                            <Col md={6} className='d-flex justify-content-end align-items-center text-end'>
                                <div className='font-regular font-size2 color-text text-wrap'>{mandateDetails.MIRCCode}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 py-1'>
                            <Col md={6} className='d-flex justify-content-start align-items-center'>
                                <div className='font-regular font-size2 color-subtext'>Mandate Start Date</div>
                            </Col>
                            <Col md={6} className='d-flex justify-content-end align-items-center text-end'>
                                <div className='font-regular font-size2 color-text text-wrap'>{mandateDetails.mandateStartDate}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 py-1'>
                            <Col md={6} className='d-flex justify-content-start align-items-center'>
                                <div className='font-regular font-size2 color-subtext'>Mandate End Date</div>
                            </Col>
                            <Col md={6} className='d-flex justify-content-end align-items-center text-end'>
                                <div className='font-regular font-size2 color-text text-wrap'>{mandateDetails.mandateEndDate}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 py-1'>
                            <Col md={6} className='d-flex justify-content-start align-items-center'>
                                <div className='font-regular font-size2 color-subtext'>Remarks</div>
                            </Col>
                            <Col md={6} className='d-flex justify-content-end align-items-center text-end'>
                                <div className='font-regular font-size2 color-text text-wrap'>{mandateDetails.remark}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 py-1'>
                            <Col md={6} className='d-flex justify-content-start align-items-center'>
                                <div className='font-regular font-size2 color-subtext'>Mandate Type</div>
                            </Col>
                            <Col md={6} className='d-flex justify-content-end align-items-center text-end'>
                                <div className='font-regular font-size2 color-text text-wrap'>{mandateDetails.mandateType}</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalBody>
            </BzModal>
        </>
    );
};

export default memo(MandateDetailsModal);

// Hari K:08-11-2023 :BT-119138:Funds View -mandate detail modal-end
